import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { YoutubePlayerComponent } from '../../../../Components/youtube-player/youtube-player.component';
import { BAC_MEDIA_CENTER_DATA } from '../bac-media.data';
import { BaseComponent } from '../../../base.component';
import { BAC_PAGES, DOMAIN_TYPE, SCHEMA_TYPE } from '../../../../constants';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import { IResponse } from '../../../../Models/response.model';
import { IList } from '../../../../Models/list.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-radio',
  standalone: true,
  imports: [PageheaderComponent, YoutubePlayerComponent, CommonModule],
  providers: [
    SchoolApiService,
    {
      provide: YOUTUBE_PLAYER_CONFIG,
      useValue: {
        disablePlaceholder: true,
      },
    },
  ],
  templateUrl: './bac-radio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacRadioComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'media_center', path: '/mediacenter' },
    children: [{ title: 'radio', path: null }],
  };

  // public RADIO_DATA = BAC_MEDIA_CENTER_DATA.radio;
  public RADIO_DATA: any;
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = BAC_PAGES.MEDIA.RADIO;

    this.onPaginateEvent();
  }

  onPaginateEvent() {
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: 10,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.RADIO_DATA = data.payload?.list.map((record) => {
            return {
              title: record.title,
              videoUrl: this.splitYoutubeIdFromURL(
                (record.youtubeUrls || [])[0]
              ),
            };
          });
          this.cdr.detectChanges();
        }
      });
  }
}
